// extracted by mini-css-extract-plugin
export default {"cls1":"VJFWG0_9SC3HP8h1XL5S","cls2":"K_nm2aS44O1OVg6Oneh6 VJFWG0_9SC3HP8h1XL5S"};